import { Loadable } from 'utils/components';
import { TERMS_PATH as path } from 'constants/paths';

export default {
  path,
  component: Loadable({
    loader: () => import(/* webpackChunkName: 'TermsAndConditionPage' */ './components/TermsAndConditionPage')
  })
};
